// Function to get a fresh CSRF token
export const getCsrfToken = async () => {
  try {
    const response = await fetch('/csrf', {
      method: 'GET',
      credentials: 'include'
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch CSRF token');
    }
    
    const data = await response.json();
    return data.csrf_token;
  } catch (error) {
    console.error('Error fetching CSRF token:', error);
    throw error;
  }
};

// Function to get headers with CSRF token
export const getHeaders = async () => {
  const token = await getCsrfToken();
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-CSRF-Token': token
  };
}; 